import React from "react";
import { Mail, Award } from "lucide-react";
import SEO from "../../../components/SEO";
import AartiImg from "../../../assets/Aarti.webp";
import Testimonials from "../../../components/Testimonials";

const Aarti = () => {


  const facts = [
    {
      title: "Éducation",
      backText:
        "Aarti est titulaire d'un baccalauréat en commerce avec une spécialisation en marketing électronique et d'une maîtrise en commerce de l'Université Panjab, Chandigarh. Sa formation académique lui a fourni une solide base en finance traditionnelle et en stratégies modernes de marketing numérique.",
    },
    {
      title: "Carrière",
      backText:
        "Après ses études supérieures, Aarti a lancé sa carrière professionnelle dans le secteur bancaire, où elle a acquis plus de quatre ans d'expérience précieuse. Elle a travaillé en étroite collaboration avec les clients pour soutenir leurs objectifs financiers — les guidant en matière d'épargne, d'investissement et de prise de décisions éclairées grâce à une planification financière personnalisée.",
    },
    {
      title: "Reconnaissance",
      backText:
        "A servi comme bénévole du Programme service national (NSS) pendant cinq ans à l'université et a été reconnue comme le meilleur bénévole du club de gestion de l'université",
    },
    {
      title: "Loisirs",
      icon: <Award size={36} />,
      backText:
        "Aarti est passionnée de danse depuis l'enfance, ayant remporté de nombreux concours au fil des ans. Embrassant son esprit entrepreneurial, elle a transformé cette passion en mission en travaillant comme instructrice de danse. Aarti aime le dessin, avec une attention particulière aux visages et aux expressions. Dans ses temps libres, elle trouve joie et sentiment de liberté dans le patin à roulettes — sa façon préférée de se détendre et de rester active.",
    },
  ];

  return (
    <>
      <SEO
        title="Aarti – Courtière en assurances   – einsured.ca"
        description="Découvrez Aarti, courtière chez einsured.ca, qui offre des conseils d’assurance personnalisés et une expertise adaptée aux besoins des clients au Canada."
        keywords="Aarti courtière en assurances, conseillère en assurance vie Canada, meilleur courtier d'assurances Brampton, expert en planification financière"
        ogType="profile"
      />
      <section
        className="min-h-screen flex flex-col justify-start md:justify-center items-center px-4 sm:px-8 md:px-24 py-12 sm:py-16"
        style={{ backgroundColor: "#f5f9ff" }}
      >
        <style>{`
          .flip-card {
            background-color: transparent;
            perspective: 1000px;
          }
          .flip-card-inner {
            position: relative;
            width: 100%;
            height: 260px;
            text-align: center;
            transition: transform 0.8s;
            transform-style: preserve-3d;
            border-radius: 24px;
            box-shadow: 0 15px 25px rgba(0, 0, 0, 0.15);
          }
          .flip-card:hover .flip-card-inner {
            transform: rotateY(180deg);
          }
          .flip-card-front,
          .flip-card-back {
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 24px;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-family: "Montserrat", sans-serif;
            font-weight: 600;
          }
          .flip-card-front {
            background: linear-gradient(to bottom, #12a5dd, #3b4f80);
            color: white;
          }
          .flip-card-back {
            background: linear-gradient(to bottom, #3b4f80, #12a5dd);
            transform: rotateY(180deg);
            color: white;
            padding: 0 1.5rem;
          }

          /* Mobile polish for flip cards */
          @media (max-width: 640px) {
            .flip-card-inner {
              height: auto;
              min-height: 260px;
            }
            .flip-card-back {
              padding: 1.25rem 1.25rem;
            }
          }
        `}</style>

        {/* TOP SECTION */}
        <div className="max-w-6xl w-full grid md:grid-cols-2 gap-10 sm:gap-12 items-start">
          {/* LEFT SIDE */}
          <div className="flex flex-col items-center md:items-start w-full">
            {/* Blue Box */}
            <div
              className="w-full rounded-t-[32px] px-6 sm:px-8 py-6 text-center md:text-left shadow-md"
              style={{ backgroundColor: "#12a5dd", color: "white" }}
            >
              <h1 className="text-3xl sm:text-4xl font-bold mb-2">Aarti</h1>
              <p className="text-base sm:text-lg font-semibold">
                Courtière en assurances
              </p>
            </div>

            {/* Bottom Blue Box */}
            <div
              className="w-full rounded-b-[32px] px-6 sm:px-8 py-8 shadow-lg"
              style={{ backgroundColor: "#12a5dd", color: "white" }}
            >
              <p className="text-sm sm:text-base leading-relaxed mb-8 sm:mb-10 text-center md:text-left">
                Originaire de Chandigarh, Aarti est titulaire d'une maîtrise en
                commerce et possède plus de quatre ans d'expérience dans le
                secteur bancaire. Elle allie expertise financière, empathie et
                souci du détail pour aider les clients à se sentir confiants et
                en sécurité dans leurs décisions financières. En dehors du
                travail, elle est danseuse formée et artiste passionnée de
                mandala et de dessin.
              </p>

              {/* CONTACT PILLS */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 sm:gap-x-8 sm:gap-y-6">
                <a
                  href="tel:+14169901800"
                  className="bg-white text-[#3b5180] font-medium text-sm sm:text-base px-6 py-3 rounded-full shadow-md text-center w-full"
                >
                  (416) 990-1800
                </a>

                <a
                  href="mailto:acl.13n@gmail.com"
                  className="bg-white text-[#3b5180] font-medium text-sm sm:text-base px-6 py-3 rounded-full shadow-md flex items-center justify-center gap-2 w-full break-all sm:break-normal"
                >
                  <Mail className="w-4 h-4" />
                  acl.13n@gmail.com
                </a>

                <a
                  href="tel:+14168400128"
                  className="bg-white text-[#3b5180] font-medium text-sm sm:text-base px-6 py-3 rounded-full shadow-md text-center w-full"
                >
                  (416) 840-0128 ext. 104
                </a>
              </div>
            </div>

            {/* Call Now */}
            <div className="text-center md:text-left mt-8 sm:mt-10 md:mt-12 w-full">
            <a
              href="https://book.einsured.ca/widget/bookings/aarti-einsured"
              className="bg-[#3b4f80] hover:bg-[#2f3d66] text-white font-semibold px-10 py-3 rounded-full shadow-md transition w-full sm:w-auto inline-block text-center"
            >
              Prendre un rendez-vous
            </a>
              <p className="text-xs sm:text-sm mt-4">
                Consultations gratuites de 15 à 30 minutes.
              </p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="flex justify-center md:justify-end mt-8 md:mt-0">
            <img
              src={AartiImg}
              alt="Aarti"
              className="rounded-[32px] shadow-md w-full max-w-xs sm:max-w-sm h-[420px] object-cover object-top"
            />
          </div>
        </div>

        {/* FACTS */}
        <div className="mt-16 sm:mt-24 max-w-6xl w-full">
          <div className="text-center mb-8 sm:mb-12 px-2">
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#49628b] mb-3 sm:mb-4">
              Quelques faits sur Aarti
            </h2>
            <p className="text-sm sm:text-lg">
              Explorez le profil d'Aarti pour mieux comprendre ses domaines
              d'expertise et ses intérêts personnels.
            </p>
          </div>

          {/* Flip Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-10 max-w-5xl mx-auto">
            {facts.map((fact) => (
              <div key={fact.title} className="flip-card cursor-pointer">
                <div className="flip-card-inner">
                  {/* FRONT */}
                  <div className="flip-card-front px-4">
                    {fact.icon && (
                      <div className="mb-3 flex justify-center">
                        {fact.icon}
                      </div>
                    )}
                    <h3 className="text-white text-xl sm:text-2xl font-bold">
                      {fact.title}
                    </h3>
                  </div>

                  {/* BACK */}
                  <div className="flip-card-back flex px-4">
                    <p className="text-white text-sm sm:text-base leading-relaxed font-normal">
                      {fact.backText}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4 EASY STEPS */}
      <section className="w-full flex justify-center bg-white py-16 sm:py-24 px-4 sm:px-8 md:px-24">
        <div className="max-w-6xl w-full grid md:grid-cols-2 gap-12 sm:gap-16 items-center">
          {/* LEFT SIDE TEXT */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#49628b] mb-4 sm:mb-5">
              4 étapes simples
            </h2>
            <p className="text-sm sm:text-lg text-[#5f6f8f] mb-8 sm:mb-10 max-w-lg">
              Obtenez votre protection en quelques minutes et profitez d'une
              couverture d'assurance vie parfaitement adaptée à vos besoins.
            </p>

            <a
              href="tel:+14169901800"
              className="bg-[#3b4f80] hover:bg-[#2f3d66] text-white font-semibold px-10 sm:px-12 py-3.5 rounded-full shadow-lg transition w-full sm:w-auto text-center"
            >
              Appelez maintenant !
            </a>
            <p className="text-xs sm:text-sm mt-4">
              Consultations gratuites de 15 à 30 minutes.
            </p>
          </div>

          {/* RIGHT SIDE */}
          <div className="bg-[#f5f8ff] rounded-[32px] shadow-lg px-6 sm:px-10 py-8 sm:py-10 md:px-14 md:py-12">
            <div className="relative pl-2 sm:pl-4">
              <div className="absolute left-6 sm:left-8 top-6 bottom-6 w-[2px] bg-[#3b4f80]/25"></div>

              {/* Step 1 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">
                  1
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">
                    Informations de base
                  </h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">
                    Répondez à quelques questions de base pour nous aider à
                    mieux vous connaître.
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">
                  2
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">
                    Analyse des besoins
                  </h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">
                    Déterminez la couverture appropriée pour protéger vos
                    proches.
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">
                  3
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">
                    Questions de santé
                  </h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">
                    Répondez à quelques questions liées à la santé pour obtenir
                    un produit adapté à vos besoins.
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-start gap-4 sm:gap-6 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">
                  4
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">
                    Obtenez votre soumission gratuite !
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Aarti;
